var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_642","data-name":"Path 642","d":"M0,0,5.153,5.245,0,10.49","transform":"translate(0.707 0.707)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1"}));
}

Arrow.defaultProps = {"width":"6.36","height":"11.904","viewBox":"0 0 6.36 11.904"};

module.exports = Arrow;

Arrow.default = Arrow;
